import React from "react";
import { Col, Row } from "antd";
import { ColumnHelper } from "../../util/TableHelper";

const PosCollectionAmountSummary = (props) => {
  return (
    <Row justify="center">
      <Col xs={24} lg={props.colSpan != undefined ? props.colSpan : 8}></Col>

      <Col
        xs={24}
        lg={props.colSpan != undefined ? 24 - props.colSpan : 4}
        style={{ textAlign: "right" }}
      >
        <div style={{ marginBottom: 10 }}>
          <p>
            Tutar:{" "}
            {props.activeAmount > 0
              ? `${ColumnHelper.renderDecimal(props.activeAmount)} `
              : undefined}{" "}
          </p>
          <p>
            Komisyon:{" "}
            {props.activeAmount > 0 && props.calculatedPayableAmount > 0
              ? `${ColumnHelper.renderDecimal(
                  props.calculatedPayableAmount - props.activeAmount
                )} `
              : undefined}{" "}
          </p>
          {props.isCommissionIncluded && (
            <p>
              Net Tutar:{" "}
              {props.activeAmount > 0 && props.calculatedPayableAmount > 0
                ? `${ColumnHelper.renderDecimal(
                    props.activeAmount -
                      (props.calculatedPayableAmount - props.activeAmount)
                  )} `
                : undefined}{" "}
            </p>
          )}
          <p>
            Komisyon Oranı:{" "}
            {props.activeAmount > 0 && props.calculatedPayableAmount > 0
              ? `% ${ColumnHelper.renderDecimal(
                  100 *
                    ((props.calculatedPayableAmount - props.activeAmount) /
                      props.activeAmount)
                )} `
              : undefined}{" "}
          </p>
          <p>
            Toplam Tutar:{" "}
            {props.payableAmount > 0
              ? `${ColumnHelper.renderDecimal(props.payableAmount)} `
              : undefined}{" "}
          </p>

          {props.isCommissionIncluded && (
            <p style={{ color: "red" }}>
              Bu işlemde komisyon oranı giriş yapılan tutara dahil edilmiştir.
            </p>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default PosCollectionAmountSummary;
